/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";
import { Navigate } from "react-router-dom";

const MessagePage = lazy(() => import("./pages/message"));
const SimPage = lazy(() => import("./pages/sim"));
const CardPage = lazy(() => import("./pages/card"));
const OperationPage = lazy(() => import("./pages/operation"));
const DashboardPage = lazy(() => import("./pages/dashboard"));
const GeneralSmsReportPage = lazy(() =>
  import("./pages/report/GeneralSmsReport")
);
const SimUnusedReportPage = lazy(() =>
  import("./pages/report/SimUnusedReport")
);
const MonthlySmsReportPage = lazy(() =>
  import("./pages/report/MonthlySmsReport")
);
const SmsImportPage = lazy(() => import("./pages/import"));

const SmsRoutes = [
  { path: "sim", element: <SimPage /> },
  { path: "message", element: <MessagePage /> },
  { path: "card", element: <CardPage /> },
  { path: "operation", element: <OperationPage /> },
  { path: "dashboard", element: <DashboardPage /> },
  { path: "general-report", element: <GeneralSmsReportPage /> },
  { path: "sim-blocks-report", element: <SimUnusedReportPage /> },
  { path: "monthly-report", element: <MonthlySmsReportPage /> },
  { path: "import-data", element: <SmsImportPage /> },
  
  { path: "*", element: <Navigate to="/sms/dashboard" /> },
];
export default SmsRoutes;
